const PHONE_REGEX = /^\d{10,15}$/;
const DEFAULT_WHATSAPP = '5511956829510';

export const SUPPORT_EMAIL = 'help@pantheon.software';
export const SUPPORT_INSTAGRAM_HANDLE = 'athena_pantheon';
export const SUPPORT_INSTAGRAM_URL = 'https://www.instagram.com/athena_pantheon/';

export function getSupportEmailHref(subject?: string): string {
  const base = `mailto:${SUPPORT_EMAIL}`;
  return subject ? `${base}?subject=${encodeURIComponent(subject)}` : base;
}

export function getSupportWhatsAppNumber(): string {
  const raw = import.meta.env.VITE_WHATSAPP_PARTNERS;
  if (typeof raw === 'string' && PHONE_REGEX.test(raw.trim())) return raw.trim();
  return DEFAULT_WHATSAPP;
}

export function hasExplicitWhatsAppEnv(): boolean {
  const raw = import.meta.env.VITE_WHATSAPP_PARTNERS;
  return typeof raw === 'string' && PHONE_REGEX.test(raw.trim());
}

export function getSupportWhatsAppHref(message?: string): string {
  const phone = getSupportWhatsAppNumber();
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${phone}${text}`;
}
